var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningCircled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 67,
    r: 65.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9422 37.9685L36.8264 81.5668C36.2879 82.4993 36.003 83.5565 36 84.6332C35.997 85.71 36.276 86.7688 36.8092 87.7042C37.3424 88.6397 38.1113 89.4193 39.0393 89.9653C39.9674 90.5114 41.0222 90.805 42.0989 90.8168H94.3306C95.4073 90.805 96.4621 90.5114 97.3901 89.9653C98.3182 89.4193 99.087 88.6397 99.6202 87.7042C100.153 86.7688 100.432 85.71 100.429 84.6332C100.426 83.5565 100.142 82.4993 99.6031 81.5668L73.4872 37.9685C72.9376 37.0623 72.1636 36.3131 71.2401 35.7931C70.3165 35.2732 69.2746 35 68.2147 35C67.1549 35 66.1129 35.2732 65.1894 35.7931C64.2658 36.3131 63.4919 37.0623 62.9422 37.9685V37.9685Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2147 53.8169V66.1502",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2147 78.4835H68.2439",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircled);
export default __webpack_public_path__ + "static/media/warning-circled.3d79bf2ce8f920d15db7a617148efdcb.svg";
export { ForwardRef as ReactComponent };